module.exports = __webpack_public_path__ + "static/media/head-shoulders.6bb0dbe1.svg";